export const SET_EQUIPMENT = 'SET_EQUIPMENT';
export const SET_WIDGET_INFO = 'SET_WIDGET_INFO';



// WEBPACK FOOTER //
// ./src/actions/types.js